module.exports = __webpack_public_path__ + "img/CAL-IEC-Case_closed.241b1a1a.png";